<template>
  <div>
    <pageHeader :headerIcon="''"
                :headerText="$t(currentTab)"
                :haveFilterInput="false"
                :hasIcon="false"
                :columnsNumber="['eight wide column', 'three wide column', 'five wide column']">
    </pageHeader>
    <div class="ui grid" style="padding-top: 10px">
      <div class="four wide column">
        <div class="ui vertical secondary pointing menu" style="width: 100%">
          <a class="item" :class="{ active: currentTab === tabs.first }"
             @click="currentTab = tabs.first">
            {{ $t('updateAuthentication') }}
          </a>
        </div>
      </div>

      <div class="twelve wide column">
        <div v-if="currentTab === tabs.first" style="margin-top: 10px">
          <updateAuthenticationPart></updateAuthenticationPart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    updateAuthenticationPart: require('@/components/users/users_components/UpdateAuthentication').default,
    updateLanguagePart: require('@/components/users/users_components/UpdateLanguage').default,
    updateStylesPart: require('@/components/users/users_components/UpdateStyles').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      tabs: {
        first: 'updateAuthentication',
        second: 'updateLanguage',
        third: 'updateStyles'
      },
      currentTab: 'updateAuthentication'
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/users/Settings.vue